import React from 'react';
import { useSelector } from 'react-redux';

import './Sidebar.css';
import Menu from './Menu';

// Thin wrapper: read role + OT licence from the session, hand them to the one
// shared Menu (menuConfig + Menu.js). `currentMenu` is kept in the signature for
// call-site compatibility but is no longer needed — Menu derives active from URL.
const SideNavigation = () => {
	const userLogin = useSelector((state) => state.userLogin);
	const session = userLogin?.userInfo?.session;
	const isAdmin = session?.role === 'admin';
	const otLicensed = session?.ot_licensed || false;
	const isProvider = session?.is_provider || false;

	return <Menu isAdmin={isAdmin} otLicensed={otLicensed} isProvider={isProvider} />;
};

export default SideNavigation;
